import React, { useMemo, useState } from "react";

const SimpleTable = ({
  columns = [],
  data = [],
  pageSize = 10,
  showSearch = true,
}) => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // 🔍 Search filter
  const filteredData = useMemo(() => {
    if (!search) return data;

    return data.filter((row) =>
      columns.some((col) => {
        const value = row[col.accessor];
        return (
          value && value.toString().toLowerCase().includes(search.toLowerCase())
        );
      }),
    );
  }, [search, data, columns]);

  // 📄 Pagination
  const totalPages = Math.ceil(filteredData.length / pageSize);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredData.slice(start, start + pageSize);
  }, [filteredData, currentPage, pageSize]);

  return (
    <div>
      {/* Search */}
      {showSearch && (
        <div style={{ marginBottom: "10px" }}>
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            style={{
              padding: "6px 10px",
              width: "220px",
              fontSize: "14px",
            }}
          />
        </div>
      )}

      {/* Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.accessor}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "left",
                  background: "#f5f5f5",
                }}
              >
                {col.Header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td
                    key={col.accessor}
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                    }}
                  >
                    {row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                style={{ textAlign: "center", padding: "12px" }}
              >
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div
          style={{
            marginTop: "12px",
            display: "flex",
            marginLeft: "85%",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <img
            style={{
              cursor: currentPage !== 1 ? "pointer" : "not-allowed",
              borderRadius: "5px",
              border: "1px solid blue",
              padding: "5px",
            }}
            width="30"
            height="30"
            src="https://img.icons8.com/ios-filled/50/back.png"
            alt="back"
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
          />

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <img
            style={{
              cursor: currentPage !== totalPages ? "pointer" : "not-allowed",
              borderRadius: "5px",
              border: "1px solid blue",
              padding: "5px",
            }}
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
            width="30"
            height="30"
            src="https://img.icons8.com/ios-filled/50/forward--v1.png"
            alt="forward"
          />
        </div>
      )}
    </div>
  );
};

export default SimpleTable;
